export const styleFooter = {
  styleTitle: {
    fontWeight: "bold",
  },
  styleText: {
    fontWeight: "300",
  },
};
